import React from 'react';
import { useState } from 'react';
import { Tag, Modal, Button, message } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { sendReservationAssetsAPI, updateTennisOrderStatusAPI, getTennisOrderAPI } from '../../apis/auction';
import i18n from '../../utils/i18n';
import './index.scss';
import { useTranslation } from 'react-i18next';


const statusColorMap = {
  NotSent: 'blue',
  Queued: 'gold',
  Sent: 'green',
  Failed: 'red',
};

const OrderTennisStatusManagerTag = ({ status, order, onStatusChange }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const statusMap = {
    NotSent: t('status.NotSent'),
    Queued: t('status.Queued'),
    Sent: t('status.Sent'),
    Failed: t('status.Failed'),
  };

  const handleTagClick = (newStatus) => {
    Modal.confirm({
      title: t('order.confirmTitle'),
      content: t('order.confirmContent', { status: statusMap[newStatus] }),
      okText: t('order.okText'),
      cancelText: t('order.cancelText'),
      onOk: async () => {
        // 如果是发送邮件（Sent），先调用发送 API，再根据结果更新状态
        if (newStatus === 'Sent') {
          if (!order) {
            message.error(t('order.missingOrder'));
            setVisible(false);
            return;
          }
          try {
            // 优先使用订单记录的语言 order.order_lang，其次使用前端当前语言，最后回退到 'ja'
            const langForEmail = (order?.order_lang === 'zh' || order?.order_lang === 'ja')
              ? order.order_lang
              : ((i18n.language === 'zh' || i18n.language === 'ja') ? i18n.language : 'ja');

            await sendReservationAssetsAPI({
              email: order.buyer_email,
              venueName: order.court_name,
              date: order.auction_date,
              timeRange: order.time_range,
              orderId: order.id,
              qrcodePath: order.reservation_account_qrcode_path ?? order.reservation_account_qr ?? undefined,
              reservationScreenshotPath: order.reservation_screenshot_path ?? undefined,
              lang: langForEmail,
            });
            try {
              await updateTennisOrderStatusAPI(order.id, 'Sent');
              message.success(t('order.sendSuccess'));
              onStatusChange && onStatusChange('Sent');
            } catch (updateErr) {
              console.warn('updateTennisOrderStatusAPI failed:', updateErr);
              message.success(t('order.sendSuccessButUpdateFailed'));
              // 根据需要仍可更新前端状态或不更新
              // onStatusChange && onStatusChange('Sent');
            }
          } catch (err) {
            console.error('sendReservationAssetsAPI error:', err);
            message.error(t('order.sendFailed'));
            onStatusChange && onStatusChange('Failed');
          } finally {
            setVisible(false);
          }
        } else {
          // 其他状态直接更新
          onStatusChange && onStatusChange(newStatus);
          setVisible(false);
        }
      },
      onCancel() {
        setVisible(false);
      },
    });
  };
  return (
    <div className='statusTennisContainer'>
      <Button
        type="link"
        size="small"
        icon={<MailOutlined />}
        onClick={() => handleTagClick('Sent')}
        title={t('order.sendReservationEmail')}
      />
      <Tag color={statusColorMap[status] || 'blue'} onClick={() => setVisible(!visible)}>
        {statusMap[status] || status}
      </Tag>
      {visible && (
        <div className='select-status'>
          {Object.keys(statusMap)
            .filter((key) => key !== status)
            .map((key) => (
              <Tag
                key={key}
                color={statusColorMap[key]}
                onClick={() => handleTagClick(key)}
              >
                {statusMap[key]}
              </Tag>
            ))}
        </div>
      )}
    </div>
  );
};

export default OrderTennisStatusManagerTag;